export default __webpack_public_path__ + "static/onboarding-a0912446783ad30b03d9cfbf060a9bca.jpg";